<template>
 <div class="w-full">
  <div class="homepage-hero-module">
    <div class="video-container" v-if="vurl">
      <div :style="fixStyle" class="filter"></div>
      <video :style="fixStyle" muted autoplay loop class="fillWidth" v-on:canplay="canplay">
        <source :src="vurl" type="video/mp4"/>
      </video>
    </div>
  </div>
  <div style="position:absolute;width:100%;top:0;z-index:10;">
    <top :selectItem="'index'"></top>
  </div>
  </div>
</template>


<script>
  import top from '../../components/common/top_lucency.vue';
  export default {
      data() {
        return {
          vedioCanPlay: false,
          fixStyle: '',
          vurl:null
        }
      },
      created () {
        this.$axios.get(this.global.url+'about/contacts').then( res => {
          this.vurl = res.data.indexVideoUrl;
        }).catch( e => {})
      },
      methods: {
        canplay() {
          this.vedioCanPlay = true
        },toResize(){
          const windowWidth = document.documentElement.clientWidth
          const windowHeight = document.documentElement.clientHeight
          const windowAspectRatio = windowHeight / windowWidth
          let videoWidth
          let videoHeight
            if (windowAspectRatio < 0.5625) {
              videoWidth = windowWidth
              videoHeight = videoWidth * 0.5625
              this.fixStyle = {
                height: windowWidth * 0.5625 + 'px',
                width: windowWidth + 'px',
                'margin-bottom': (windowHeight - videoHeight) / 2 + 'px',
                'margin-left': 'initial'
              }
            } else {
              videoHeight = windowHeight
              videoWidth = videoHeight / 0.5625
              this.fixStyle = {
                height: windowHeight + 'px',
                width: windowHeight / 0.5625 + 'px',
                'margin-left': (windowWidth - videoWidth) / 2 + 'px',
                'margin-bottom': 'initial'
              }
            }
        }
      },
      components:{top},
      mounted: function() {
        window.addEventListener('resize', this.toResize);
      },beforeDestroy () {
        window.removeEventListener("scroll",this.toResize)
      }
    }
</script>

<style scoped>

  .homepage-hero-module,
    .video-container {
      position: relative;
      height: 100vh;
      overflow: hidden;
    }

    .video-container .poster img,
    .video-container video {
      z-index: 0;
      /* position: absolute; */
      width:100%;
      object-fit:cover;
    }

    .video-container .filter {
      z-index: 1;
      position: absolute;
      background: rgba(38, 18, 77, 0.4);
    }

    .aacontent {
        padding:10px;
        background:green;
        color:#fff;
        position:absolute;
        top:50%;
        left:50%;
        border-radius: 5px;
        -webkit-transform: translate(-50%,-50%);
        -moz-transform: translate(-50%,-50%);
        transform:translate(-50%,-50%);
    }
</style>
